import { BaseState } from '../types';

export enum UserTypes {
  DisplayUserInfo = '@user/DISPLAY_USER_INFO',
}

export interface UserState extends BaseState {
  name: string;
}
